export const RevertArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <path
              d="M0 0H24V24H0z"
              transform="translate(-845 -53) translate(371 26) translate(474 27)"
            />
            <path
              fill="#3B3B3B"
              d="M12 8c4.686 0 8.62 3.224 9.704 7.575l-1.94.485C18.895 12.58 15.748 10 12 10c-2.782 0-5.233 1.42-6.666
               3.576l1.535 1.288L2 16l.273-4.993 1.521 1.276C5.602 9.693 8.603 8 12 8z"
              transform="translate(-845 -53) translate(371 26) translate(474 27)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
